import { isValidSplitInput, REVIEW_CONTRACT_OPTIONS } from "../../../payments/utils/paymentFormUtils";
import { CONTRACT_PIP_OPTIONS } from "../../utils/contractFormUtils";

import ContractsDateField from "./ContractsDateField";
import ContractsFileField from "./ContractsFileField";
import ContractsModalField from "./ContractsModalField";
import ContractsSingleSelectDropdown from "./ContractsSingleSelectDropdown";
import ContractsTextField from "./ContractsTextField";

const DECIMAL_ONLY = /^\d*\.?\d*$/;

export default function ContractsEditForm({ formValues, onChange, mode = "edit" }) {
  return (
    <div className="flex flex-col gap-4 p-6">
      <div className="flex w-full flex-row gap-4">
        <ContractsModalField
          label="Contract Name"
          renderValue={
            <ContractsTextField
              fieldName="contractName"
              fieldValue={formValues.contractName}
              onChange={onChange}
            />
          }
        />
      </div>

      <div className="flex w-full flex-row gap-4">
        <ContractsModalField
          label="Start Date"
          renderValue={
            <ContractsDateField
              fieldName="startDate"
              fieldValue={formValues.startDate}
              onChange={onChange}
            />
          }
        />
        <ContractsModalField
          label="Term Date"
          renderValue={
            <ContractsDateField
              fieldName="termDate"
              fieldValue={formValues.termDate}
              onChange={onChange}
            />
          }
        />
      </div>

      <div className="flex w-full flex-row gap-4">
        <ContractsModalField
          label="EIN"
          renderValue={
            <ContractsTextField
              fieldName="employerIdentificationNumber"
              fieldValue={formValues.employerIdentificationNumber}
              onChange={onChange}
            />
          }
        />
        <ContractsModalField
          label="PIP"
          renderValue={
            <ContractsSingleSelectDropdown
              fieldName="pipState"
              fieldValue={formValues.pipState}
              onChange={onChange}
              data={CONTRACT_PIP_OPTIONS}
            />
          }
        />
        {mode === "add" && (
          <ContractsModalField
            label="Review Contract for Exhibit"
            renderValue={
              <ContractsSingleSelectDropdown
                fieldName="reviewContract"
                fieldValue={formValues.reviewContract}
                onChange={onChange}
                data={REVIEW_CONTRACT_OPTIONS}
              />
            }
          />
        )}
      </div>

      {mode === "add" && (
        <div className="flex w-full flex-row gap-4">
          <ContractsModalField
            label="MRS Split"
            renderValue={
              <ContractsTextField
                fieldName="clientManagementSplit"
                fieldValue={formValues.clientManagementSplit}
                onChange={onChange}
                inputMode="decimal"
                pattern={DECIMAL_ONLY}
                validator={(value) => isValidSplitInput(value, 3)}
              />
            }
          />
          <ContractsModalField
            label="Provider Split"
            renderValue={
              <ContractsTextField
                fieldName="providerSplit"
                fieldValue={formValues.providerSplit}
                onChange={onChange}
                inputMode="decimal"
                pattern={DECIMAL_ONLY}
                validator={(value) => isValidSplitInput(value, 3)}
              />
            }
          />
          <ContractsModalField
            label="Marketing Split"
            renderValue={
              <ContractsTextField
                fieldName="marketingSplit"
                fieldValue={formValues.marketingSplit}
                onChange={onChange}
                inputMode="decimal"
                pattern={DECIMAL_ONLY}
                validator={(value) => isValidSplitInput(value, 3)}
              />
            }
          />
        </div>
      )}

      <div className="flex w-full flex-row gap-4">
        <ContractsFileField fieldValue={formValues.contractFile} onChange={onChange} />
      </div>
    </div>
  );
}
